import React from 'react';

import LayoutPage from 'src/modules/layout/components/page/LayoutPage';
import { ProductsListingOverview } from 'src/modules/products';
import { LayoutBlockHero } from 'src/modules/layout';
import { LayoutDynamicZone } from 'src/modules/layout';
import { useIntl } from 'react-intl';
import { useLocale } from 'src/modules/locale';
import { ProductSeriesEntity } from 'src/modules/products';
import useRedrawOnMountKey from 'src/utils/useRedrawOnMountKey';

interface ProductsSeriesPageProps {
  page: ProductSeriesEntity;
}

const ProductsSeriesPage: React.FunctionComponent<ProductsSeriesPageProps> = (props) => {
  const intl = useIntl();
  const { getLocalizedObject } = useLocale();

  // language not updating on SSG workaround
  const redrawKeyHero = useRedrawOnMountKey();

  if (!props.page) {
    return null;
  }

  const {
    page: { name, slug, description, products, dynamic_content, hero_label, image },
  } = getLocalizedObject(props);

  const title = intl.formatMessage({ id: 'page/products/series/title' }, { name });

  const pageProperties = {
    title,
    description,

    breadcrumbs: [
      {
        title: intl.formatMessage({
          id: 'breadcrumbs/products',
        }),
        as: '/products',
        href: '/products',
      },
      {
        title: intl.formatMessage({
          id: 'breadcrumbs/products/family',
        }),
        // there is no /products/family page
        as: `/products/family/${encodeURIComponent(slug)}`,
        href: '/products/family/[slug]',
      },
      {
        title: name,
        as: `/products/family/${encodeURIComponent(slug)}`,
        href: '/products/family/[slug]',
      },
    ],
  };

  return (
    <LayoutPage {...pageProperties}>
      <LayoutBlockHero
        key={redrawKeyHero}
        label={hero_label}
        title={title}
        subline={description}
        image={image}
      />
      {dynamic_content && <LayoutDynamicZone components={dynamic_content} />}
      <ProductsListingOverview oneRow={false} products={products} />
    </LayoutPage>
  );
};

export default ProductsSeriesPage;
